import { Component, Input } from '@angular/core';
import { GlobalMessageService } from '../../global-services/global-message.service';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

@Component({
    selector: 'app-global-copy-to-clipboard',
    imports: [...COMMON_IMPORTS],
    template: `
    <button 
      pButton 
      type="button" 
      class="flex align-items-center justify-content-center p-button-secondary"
      (click)="copy()"
      icon="pi pi-copy"
    ></button>
  `
})
export class GlobalCopyToClipboardComponent {
  @Input() text = '';
  @Input() label = 'Copy';

  public constructor(private readonly messageService: GlobalMessageService) {}

  async copy() {
    if (!this.text) return;
    await navigator.clipboard.writeText(this.text);
    this.messageService.showSuccess("Copy Success", "Text copied to clipboard!");
  }
}